import { DateTime } from 'luxon';
import { ConsultationType, IDataForCreateConsultation } from 'src/pages/types';
import { environment } from '../enviroments';
import { HttpHandler } from './HttpHandler';
import { ReviewData } from '../redux/consultationReviews/consultationsReviews.reducer';

export const getConsultationByID = async (consultationID: string): Promise<ConsultationType> => {
  const { data: consultation } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONSULTATION_APP_URL}/consultations/client/${consultationID}`,
  });

  return consultation.data;
};

export const getConsultationsByUserId = async (query?: string): Promise<any> => {
  const { data: consultations } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONSULTATION_APP_URL}/consultations/client/list`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return consultations.data ? (consultations.data as Array<ConsultationType>) : [];
};

export const getFutureConsultationsByUserId = async (query?: string): Promise<any> => {
  const { data: consultations } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONSULTATION_APP_URL}/consultations/client/list?orderBy=consultation_time.asc&consultation_time=more:${DateTime.local(
      {
        zone: 'UTC',
      }
    )
      .minus({ minutes: 50 })
      .toISO()}&limit=20`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return consultations.data ? (consultations.data as Array<ConsultationType>) : [];
};

export const getPreviousConsultationsByUserId = async (query?: string): Promise<any> => {
  const { data: consultations } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONSULTATION_APP_URL}/consultations/client/list_v2?orderBy=consultation_time.desc&consultation_time=less:${DateTime.local(
      {
        zone: 'UTC',
      }
    )
      .minus({ minutes: 50 })
      .toISO()}&limit=10${query ? `&${query}` : ''}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return {
    list: consultations.data?.list ? (consultations.data?.list as Array<ConsultationType>) : [],
    total: consultations.data?.total,
  };
};

export const createConsultationByAvailableBalance = async (
  data: IDataForCreateConsultation
): Promise<ConsultationType> => {
  const createdConsultation = await HttpHandler({
    url: `${environment.BOOKING_URL}/${data.userID}`,
    method: 'POST',
    data,
  });

  return createdConsultation.data;
};

export const createConsultationByAvaialableCouponBalance = async (data: IDataForCreateConsultation) => {
  const createdConsultation = await HttpHandler({
    url: `${environment.CONSULTATION_APP_URL}/consultations/balance/trial`,
    method: 'POST',
    data,
  });

  return createdConsultation.data;
};

export const rescheduleSession = async (consultationID: string | undefined, startDate: string | undefined) => {
  await HttpHandler({
    method: 'PATCH',
    url: `${environment.CONSULTATION_URL}/${consultationID}`,
    data: {
      consultation_time: startDate,
    },
  });
};

export const createNewConsultationReview = async (data: Omit<ReviewData, 'currentSpecialist'>) => {
  const { data: createdReviewData } = await HttpHandler({
    method: 'POST',
    url: `${environment.CONSULTATION_URL}/specialists/${data.specialist_id}/users/${data.client_id}/consultations/${data.consultation_id}/reviews/`,
    data,
  });

  return createdReviewData;
};

export const getRatedConsultationsReviews = async (userId: string) => {
  const { data: createdReviewData } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONSULTATION_URL}/users/${userId}/reviews/`,
  });
  return createdReviewData.data;
};
